<template>
  <v-app>
    <v-content>
      <v-container fill-height>
        <v-layout
          align-center
          justify-center
        >
          <v-flex lg5>
            <v-toolbar>
              <v-toolbar-title>
                Login
              </v-toolbar-title>
            </v-toolbar>
            <v-card>
              <v-card-text>
                <alert
                  v-if="hasErrors !== null"
                  :message="hasErrors"
                  type="error"
                />
                <login-form />
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Alert from '@/components/Utilities/Alert'
import LoginForm from './components/LoginForm'
import { mapGetters } from 'vuex'
export default {
  components: {
    LoginForm,
    Alert
  },
  computed: {
    ...mapGetters({
      hasErrors: 'auth/hasErrors'
    })
  }
}
</script>
